import * as ROUTES from '@Router/routes';

export const READ_ONLY_LIST_TYPES = ['streaming', 'photo', 'photoset'];

const LIST_TYPE_TO_API_PATH = {
	streaming: 'streamings',
	photo: 'photos',
	photoset: 'photosets',
};

const ITEM_TYPE_TO_API_PATH = {
	streaming: 'streamings',
	photo: 'photo',
	photoset: 'photoset',
	photos: 'photo',
	photosets: 'photoset',
};

export function isReadOnlyListType(type) {
	return READ_ONLY_LIST_TYPES.includes(type);
}

export function getListApiPath(type) {
	return LIST_TYPE_TO_API_PATH[type] || `${type}s`;
}

export function getItemApiPath(type) {
	if (ITEM_TYPE_TO_API_PATH[type]) {
		return ITEM_TYPE_TO_API_PATH[type];
	}
	return type;
}

export function getDetailRoutePath(type, epId) {
	return `${ROUTES.MEDIA}/${getItemApiPath(type)}/${epId}`;
}
